

'use strict';

var processInclude = require('@sfra/util');

$(document).ready(function () {
    processInclude(require('@plugin_wishlists/wishlist/wishlist'));
    processInclude(require('./wishlist/bbw-wishlist'));
});
